import React from "react";
import { Link } from "react-router-dom";
import { formatUSD, formatInt } from "@/lib/api";
import { Gauge, Calendar, MapPin } from "lucide-react";

export const EquipmentCard = ({ item, index = 0 }) => {
  const img = item.images?.[0] || "https://images.pexels.com/photos/4040619/pexels-photo-4040619.jpeg";
  return (
    <Link
      to={`/equipment/${item.id}`}
      data-testid={`equipment-card-${item.id}`}
      style={{ animationDelay: `${Math.min(index, 10) * 40}ms` }}
      className="fade-up group block border border-[#27272A] bg-[#141415] transition-colors duration-200 hover:border-[#FFB800]"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-black">
        <img
          src={img}
          alt={item.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-0 top-0 flex items-center gap-2 p-3">
          {item.featured && (
            <span className="bg-[#FFB800] px-2 py-1 font-display text-[10px] font-bold uppercase tracking-[0.2em] text-black">
              Featured
            </span>
          )}
          {item.sold && (
            <span className="bg-red-600 px-2 py-1 font-display text-[10px] font-bold uppercase tracking-[0.2em] text-white">
              Sold
            </span>
          )}
        </div>
        <div className="absolute right-0 top-0 bg-black/70 px-3 py-1 font-mono text-[11px] uppercase tracking-widest text-white">
          {item.category}
        </div>
      </div>
      <div className="border-t border-[#27272A] p-5">
        <div className="flex items-center justify-between font-mono text-[11px] uppercase tracking-[0.2em] text-[#FFB800]">
          <span>{item.brand}</span>
          <span>{item.condition}</span>
        </div>
        <h3 className="mt-2 font-display text-xl font-bold uppercase leading-tight text-white group-hover:text-[#FFB800]">
          {item.title}
        </h3>
        <div className="mt-4 grid grid-cols-3 gap-3 border-t border-[#27272A] pt-4 text-[11px] uppercase tracking-wider text-white/60">
          <div className="flex items-center gap-1.5">
            <Calendar className="h-3.5 w-3.5 text-[#FFB800]" />
            {item.year}
          </div>
          <div className="flex items-center gap-1.5">
            <Gauge className="h-3.5 w-3.5 text-[#FFB800]" />
            {formatInt(item.hours)} hr
          </div>
          <div className="flex items-center gap-1.5 truncate">
            <MapPin className="h-3.5 w-3.5 flex-shrink-0 text-[#FFB800]" />
            <span className="truncate">{item.location?.split(",")[0]}</span>
          </div>
        </div>
        <div className="mt-5 flex items-end justify-between">
          <div className="font-display text-3xl font-black text-white">
            {formatUSD(item.price)}
          </div>
          <span className="font-display text-xs font-bold uppercase tracking-widest text-[#FFB800] group-hover:translate-x-1 transition-transform">
            View →
          </span>
        </div>
      </div>
    </Link>
  );
};
